export const searchObjByPath = (obj: { [key: string]: any }, path: string[]): any => {
  // If the path is empty, return undefined
  if (path.length === 0) {
    return undefined;
  }

  // Get the current key from the path
  const currentKey: string = path[0];

  // If the current key doesn't exist in the object, return undefined
  if (!(currentKey in obj)) {
    return undefined;
  }

  // If this is the last key in the path, return the value
  if (path.length === 1) {
    return obj[currentKey];
  }

  // Recursively call the function with the next key and the nested object
  return searchObjByPath(obj[currentKey], path.slice(1));
};
